export default "__VITE_ASSET__CQOP87Uw__"